export default "__VITE_ASSET__CBFXQ3wO__"